import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { ObserveMultiState } from "../../../CommonUI/StateManagement/ObserveMultiState";
import { GroupedBracketedDiv } from "../Logic/AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { DateEqualToExpression } from "../../../rule-engine-core/Expressions/Expressions/Date/DateEqualToExpression";

export class DateEqualToExpressionEditor extends ExpressionRuleEditor<DateEqualToExpression> {
    render() {
        return (
            <ObserveMultiState
                listenTo={[this.ruleData!.value1!, this.ruleData!.value2!]}
                control={() => (
                    <GroupedBracketedDiv
                        issue={this.ruleData!.getValidationIssues()[0]}
                        hasChild={!!this.ruleData!.value1!.subExpression || !!this.ruleData!.value2!.subExpression}
                    >
                        <ExpressionPiece hasChild={!!this.ruleData!.value1!.subExpression}>
                            <ExpressionValueRenderer el={this.ruleData!.value1!} />
                        </ExpressionPiece>
                        <ExpressionPiece> {"="} </ExpressionPiece>
                        <ExpressionPiece hasChild={!!this.ruleData!.value2!.subExpression}>
                            <ExpressionValueRenderer el={this.ruleData!.value2!} />
                        </ExpressionPiece>
                    </GroupedBracketedDiv>
                )}
            />
        );
    }
}
